import { InlineError, Input } from 'avo-ui'
import UploadImage from 'components/commons/upload-image'
import TabToggle from 'components/commons/tab-toogle'

export const General = ({ dailyDealsDetail, onChangeForm, errorForm }) => {
    return (
        <TabToggle
            title={'General'}
            content={
                <div className={'flex space-x-16'}>
                    <div className={'flex-1 flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Text Title</div>
                        <Input
                            className={'flex-1'}
                            name={'title'}
                            placeholder={'Masukkan text title'}
                            value={dailyDealsDetail?.title}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.daily_deal?.title} />
                    </div>
                    <div
                        className={`flex-1 flex-col ${(dailyDealsDetail?.title_image_url?.base64 || dailyDealsDetail?.title_image_url) && 'space-y-3'}`}
                    >
                        <div className={'font-semibold text-blue-90'}>Image Title</div>
                        <UploadImage
                            className={'w-fit'}
                            classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                            id={'image-title'}
                            value={dailyDealsDetail?.title_image_url?.base64 || dailyDealsDetail?.title_image_url}
                            onChange={(value) => onChangeForm({ name: 'title_image_url', value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.daily_deal?.title_image_url} />
                    </div>
                </div>
            }
        />
    )
}
